<span class="tw-truncate tw-text-sm tw-font-normal tw-leading-normal tw-text-gray-700">{{ option().name }}</span>
<span class="tw-shrink-0 tw-rounded-md tw-bg-blue-100 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-medium tw-leading-normal tw-text-blue-800">
  {{ option().registrationCount }}
</span>
